import React from 'react'

export const Footer = () => {
  return (
    <footer className="bg-white-500  mt-4 py-8">
    <div className="container mx-auto text-center">
      <p>&copy; 2023 PGDOST. All rights reserved.</p>
    </div>
  </footer>
  )
}
